import RequestService from "./RequestService";
import { Assistant } from "../entities/company/Assistant/Assistant";

class AssistantService {
    public static async aicategorize(id: number): Promise<Error> {
        return RequestService.post("/assistant/aicategorize", { id });
    } 

    public static async getInstructions(): Promise<Assistant | Error> {
        return RequestService.post("/assistant/get", {});
    }

    public static async setInstructions(assistant: Assistant) {
        return RequestService.post("/assistant/set", { item: assistant });
    }

}

export default AssistantService;